export const GET_ARTIST = 'GET_ARTIST';
export const RESET_ARTIST = 'RESET_ARTIST';
export const UPDATE_SKILLS = 'UPDATE_SKILLS';
